export default __webpack_public_path__ + "static/media/Stefaneanu.097c9fb0.jpg";